// Basic hyphens style
export const baseHyphensStyle = `
  hyphens: auto;
`;